// extracted by mini-css-extract-plugin
export default {"overlay":"MarketClosedOverlay_overlay__4DcBt","label":"MarketClosedOverlay_label__B7b29"};